import { useEffect, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WCta } from '../WCta';
import { WregPhase } from '../WregPhase';
import { WregRadioGroup, type WregRadioOption } from '../WregRadioGroup';
import { WREG_WORKING_MS } from '../wregSteps';

type WregLabsAnswer = 'yes' | 'no';

type Props = {
  initial?: boolean | null;
  onYes: () => void;
  onNo: () => void;
};

const OPTIONS: WregRadioOption<WregLabsAnswer>[] = [
  ['yes', 'wreg.labs.yes'],
  ['no', 'wreg.labs.no'],
];

const toAnswer = (value: boolean | null | undefined): WregLabsAnswer | null =>
  typeof value === 'boolean' ? (value ? 'yes' : 'no') : null;

const WregLabs = ({ initial, onYes, onNo }: Props) => {
  const { t } = useTranslation();
  const titleId = useId();
  const [ans, setAns] = useState<WregLabsAnswer | null>(toAnswer(initial));
  useEffect(() => {
    setAns((prev) => prev ?? toAnswer(initial));
  }, [initial]);
  return (
    <div className="rg-screen">
      <div className="rg-body">
        <div className="rg-inner">
          <div className="rg-head-block">
            <WregPhase n={3} />
            <h1 className="rg-h1" id={titleId}>
              {t('wreg.labs.title')}
            </h1>
            <p className="rg-sub wreg-labs-sub">{t('wreg.labs.sub')}</p>
          </div>
          <WregRadioGroup
            value={ans}
            onSelect={setAns}
            options={OPTIONS}
            labelledBy={titleId}
          />
        </div>
      </div>
      <div className="rg-foot">
        <WCta
          disabled={!ans}
          working={t('wreg.labs.cta_loading')}
          minWorkingMs={WREG_WORKING_MS}
          onDone={() => (ans === 'yes' ? onYes() : onNo())}
        >
          {t('wreg.labs.cta')}
        </WCta>
      </div>
    </div>
  );
};

export { WregLabs };
